(function () {
  'use strict';
  const escapeText = (text) => String(text).replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
  const formatNote = (text) => text ? `<div class="refine-print">${escapeText(text)}</div>` : '';
  const decodeAttribute = (text) => text.replace(/&(amp|lt|gt|quot|#39);/g, (entity) => ({ '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#39;': "'" }[entity]));

  // Production metadata stays on the line items; the buyer note carries customer messages.
  function configuredItems(items, quantities) {
    const configurations = new Map();
    items.forEach((item) => {
      const p = item.properties || {};
      const quantity = Number(quantities[item.key] ?? item.quantity);
      if (!Number.isInteger(quantity) || quantity <= 0 || item.requires_shipping === false) return;
      // Equivalent Shopify rows can split when a discount applies. Their
      // production properties, variant, and SKU identify one configuration.
      const identity = JSON.stringify([item.sku, item.variant_id || item.variant_title || '', p]);
      const previous = configurations.get(identity);
      if (previous) previous.quantity += quantity;
      else configurations.set(identity, { ...item, quantity });
    });
    return [...configurations.values()];
  }

  function personalizationLines(p) {
    const locations = Object.keys(p).filter((key) => !key.startsWith('_') && key.endsWith(' design'));
    if (!locations.length && !p['Engraving design'] && p['Engraving'] !== 'Personalized') return [];
    const lines = [];
    if (!locations.length) {
      if (p['Engraving design']) lines.push(`Design: ${p['Engraving design']}`);
      else lines.push(`Engraving: ${p['Engraving']}`);
      ['Line 1', 'Line 2', 'Line 3'].forEach((key) => { if (p[key]) lines.push(`${key}: ${p[key]}`); });
    }
    locations.forEach((key) => {
      const location = key.slice(0, -7);
      const design = String(p[key]);
      lines.push(`${location} · ${design.replace(/^FACE-0?([1-6])$/, 'Design $1')}`);
      // Initial designs put the initial above the name; preserve physical lettering order.
      const values = ['initial', 'name', 'date'].map((field) => p[`${location} ${field}`]).filter((value) => value);
      values.forEach((value, index) => lines.push(`Line ${index + 1}: ${value === '[intentionally omitted]' ? '[omitted]' : value}`));
    });
    return lines;
  }

  function summarize(items, quantities, giftMessage) {
    const boards = configuredItems(items, quantities).filter((item) => !item.properties?.['_Parent product']).flatMap((item) => {
      const lines = personalizationLines(item.properties || {});
      return lines.length ? [[`${item.sku || item.product_title} · Qty ${item.quantity}`, ...lines].join('\n')] : [];
    });
    const blocks = [];
    if (boards.length) blocks.push(`PERSONALIZATION\n${boards.join('\n\n')}`);
    if (giftMessage.trim()) blocks.push(`GIFT MESSAGE\n${giftMessage.trim()}`);
    return blocks.join('\n\n');
  }

  function renderNote(giftMessage, customerComment) {
    const blocks = [];
    if (giftMessage.trim()) blocks.push(`Gift message:\n${giftMessage.trim()}`);
    if (customerComment.trim()) blocks.push(`Customer comment:\n${customerComment.trim()}`);
    return blocks.join('\n\n');
  }

  function parseNote(value) {
    value = value.replace(/\r\n?/g, '\n');
    const giftHeader = 'Gift message:\n';
    const commentHeader = 'Customer comment:\n';
    const separator = `\n\n${commentHeader}`;
    if (value.startsWith(giftHeader)) {
      const split = value.indexOf(separator, giftHeader.length);
      return split < 0
        ? { gift: value.slice(giftHeader.length), comment: '' }
        : { gift: value.slice(giftHeader.length, split), comment: value.slice(split + separator.length) };
    }
    if (value.startsWith(commentHeader)) return { gift: '', comment: value.slice(commentHeader.length) };
    return null;
  }

  function init(form) {
    const note = form.querySelector('[data-packing-note]');
    const gift = form.querySelector('[data-gift-message]');
    const team = form.querySelector('[data-team-note]');
    const giftAttribute = form.querySelector('[data-gift-attribute]');
    const teamAttribute = form.querySelector('[data-team-attribute]');
    if (!note || !gift || !team || !giftAttribute || !teamAttribute) return false;
    if (form.dataset.packingVersion === '2') {
      gift.value = decodeAttribute(gift.value);
      team.value = decodeAttribute(team.value);
    } else {
      const saved = parseNote(note.value || '');
      if (saved) {
        gift.value = saved.gift;
        team.value = saved.comment;
      } else if (note.value) {
        team.value = note.value;
      }
    }
    const sync = () => {
      note.value = renderNote(gift.value, team.value);
      // Clear old cart attributes: ShipStation appends them as literal HTML to buyer notes.
      giftAttribute.value = '';
      teamAttribute.value = '';
    };
    // Run after linked-add-on quantity synchronization in initCart.
    form.addEventListener('submit', sync);
    gift.addEventListener('input', sync);
    team.addEventListener('input', sync);
    sync();
    return true;
  }

  window.refinePackingSlip = { summarize, renderNote, parseNote, formatNote, escapeText, decodeAttribute, init };
}());
